import * as React from 'react';

type BreadcrumbProps = {
  data?: BreadcrumbItem[];
  path?: 'new' | 'edit';
};

type BreadcrumbItem = {
  url: string;
  icon?: string;
  label: string;
};

/**
 * Breadcrumb Component
 * Displays navigation breadcrumb for workout routine pages
 *
 * Migration Notes:
 * - Previously used WorkoutRoutineContext for workoutRoutinePath
 * - Now accepts path as a prop directly
 * - Requirements: 7.3 - Remove legacy context dependencies
 */
const Breadcrumb = ({data, path = 'new'}: BreadcrumbProps) => {
  const BreadcrumData = [
    {
      label: 'Treinos',
      url: `/${window.account}/admin/workout-routines/`,
      icon: 'stopwatch',
    },
    {
      label:
        path === 'new' ? 'Criar Rotina de Treinos' : 'Editar Rotina de Treinos',
      url: null,
    },
  ];

  return (
    <nav className="breadcrumb" aria-label="breadcrumb">
      <div className="nav-wrapper">
        <div className="col s12">
          {(data || BreadcrumData).map((item, index) => (
            <a
              key={`breadcrumb-${index}`}
              className="breadcrumb"
              href={item.url}>
              {!!item?.icon && (
                <span className="breadcrumb-icon">
                  <i className={`fal fa-${item.icon}`}></i>&nbsp;
                </span>
              )}
              <span>{item.label}</span>
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Breadcrumb;
